import { useWorkspace } from '@/contexts/WorkspaceContext'

export type { Workspace } from '@/contexts/WorkspaceContext'

/**
 * Drop-in replacement for the old useCurrentWorkspace hook.
 * Delegates to WorkspaceContext (soft refresh, no page reload).
 */
export function useCurrentWorkspace() {
  const { workspace, isLoading, isLoggedIn, switchWorkspace } = useWorkspace()
  return { workspace, isLoading, isLoggedIn, switchWorkspace }
}

/**
 * Standalone workspace switch for use outside WorkspaceProvider
 * (onboarding, auth pages). Sets cookie + localStorage, then navigates.
 */
export function setWorkspaceAndNavigate(workspaceId: string, navigateTo = '/campaigns') {
  localStorage.setItem('currentWorkspaceId', workspaceId)
  document.cookie = `currentWorkspaceId=${workspaceId}; path=/; max-age=${60 * 60 * 24 * 365}; SameSite=Lax`
  window.location.href = navigateTo
}
